// Not in use.


import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ProSubscriptionOverlay = ({ onClose }) => {
  return (
    <Modal show={true} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upgrade to FinTorro Pro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <li>AI-assisted learning.</li>
  <li>Unlimited Lessons</li>
 <li>Unlimited Courses</li>
 <li>Unlimited Practice Sessions</li>
<li>Unlimited Mistakes</li>
<li>Learn with AI</li>
 <li>10,000 Lessons</li>
 <li>Join Challenges</li>
 <li>Includes Crypto, Forex, Psychology</li>
        <Button
          style={{ backgroundColor: "#FF7C24", borderColor: "#FF7C24", width: "100%" }}
          onClick={() => window.open("https://buy.stripe.com/eVa29y1Ig8zsgFycMZ", "_blank")}
        >
          Upgrade Now
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ProSubscriptionOverlay;
